import { render, staticRenderFns } from "./_base-chip.vue?vue&type=template&id=9e194542&scoped=true&"
import script from "./_base-chip.vue?vue&type=script&lang=js&"
export * from "./_base-chip.vue?vue&type=script&lang=js&"
import style0 from "./_base-chip.vue?vue&type=style&index=0&id=9e194542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e194542",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
